/** Home hub layout dimensions (Figma "New Experiment" frame). */
export const HOME_LAYOUT_SIZES = {
  hubMaxWidth: 768,
  contentPaddingX: 32,
  contentPaddingY: 64,
  headerGap: 8,
  headerToSubtitleGap: 16,
  subtitleToCardsGap: 56,
  cardGridGap: 24,
  tallCardMinHeight: 347,
  wideCardMinHeight: 132,
  cardRadius: 16,
  cardPadding: 32,
  cardContentGap: 12,
  cardSectionGap: 20,
  stepBadgeSize: 36,
  ctaHeight: 36,
  ctaRadius: 10,
} as const;

/** Staggered entrance delays for the Home hub (milliseconds). */
export const HOME_ENTRANCE_DELAYS = {
  greeting: 0,
  heading: 140,
  subtitle: 280,
  cardCreate: 460,
  cardAnalyze: 580,
  cardLibrary: 700,
} as const;

export const HOME_ENTRANCE_DURATION_MS = 520;
export const HOME_ENTRANCE_OFFSET_PX = 14;
